<div [ngClass]="{'is-active' : active}" class="modal" id="modal-comp" data-testid="modal-component">
  <div (click)="closeModal()" *ngIf="closeable; else non_closeable_background" class="modal-background"></div>

  <ng-template #non_closeable_background>
    <div class="modal-background"></div>
  </ng-template>

  <div class="modal-card" [ngStyle]="{ 'width.px':width}">
    <section #scrollBar id="scrollbar" class="modal-card-body"
             style="padding: 5px !important;padding-top: 0; border-radius: 25px;">
      <div style="padding: 20px;">
        <button *ngIf="closeable"
                [ngClass]="(mobile)?'delete deleteButtonMobile':'delete deleteButton'"  aria-label="delete"
                (click)="closeModal()"></button>
        <ng-content></ng-content>
      </div>
    </section>
  </div>
</div>
